import { formatAssetAmount } from "../../utils/decimal";
import "./wallets.scss";
import { FunctionComponent } from "react";
import { MoveUpRight, MoveDownRight, History as HistoryIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { WalletInterface } from "../../models/Wallet";
import { Balance } from "../../models/Balance";
import { useAppSelector } from "../../features/helpers";

interface WalletsProps {
    wallets: WalletInterface[];
    /** Quando informado, o botao "Historico" vira link pra essa rota. */
    historyHref?: string;
}

type Variation = {
    valueFixed: number;
    direction: number;
};

const Wallets: FunctionComponent<WalletsProps> = ({ wallets, historyHref }: WalletsProps) => {

    // Empresa do cliente: a carteira nem sempre tem organization_id (cliente
    // registrado/convidado). Quando o cliente tem exatamente uma organizacao
    // vinculada, usa ela como nome de empresa do card.
    const orgs = useAppSelector((s) => s.user.userInfo.organizationUsers);
    const clientOrgName = orgs && orgs.length === 1
        ? orgs[0]?.organization?.organizationName
        : undefined;

    const checkVariation = (balances: Balance[]): Variation => {
        if (balances.length <= 1) return { valueFixed: 0, direction: 0 };

        const last = balances[balances.length - 1];
        let value = 0;
        if (+last.last_amount === 0) value = 100;
        else value = ((+last.amount - +last.last_amount) / +last.last_amount) * 100;

        let direction = 0;
        if (value > 0) direction = 1;
        else if (value < 0) direction = -1;

        return { valueFixed: Number(value.toFixed(2)), direction };
    };

    return (
        <div className="wallets-warpper">
            <ul className="wallets">
                {wallets.map((wallet: WalletInterface, index) => {

                    let variation = { valueFixed: 0, direction: 0 };
                    if (wallet.balances) variation = checkVariation(wallet.balances);

                    const companyName = wallet.organization?.organizationName || clientOrgName;

                    return (
                        <li key={index} className="card-wallet">

                            <h3>
                                <span className="circle">{wallet.asset.symbol}</span>
                                <div className="meta">
                                    <strong title={companyName}>
                                        {companyName || wallet.asset.symbol}
                                    </strong>
                                    <small>{wallet.nickname || "wallet"}</small>
                                </div>
                            </h3>

                            <div className="row">
                                <span className="amount">
                                    {wallet.asset.symbol} {formatAssetAmount(wallet.balance, wallet.asset.symbol)}
                                </span>

                                <span className={
                                    variation.direction === 1
                                        ? "delta positivo"
                                        : variation.direction === -1
                                        ? "delta negativo"
                                        : "delta"
                                }>
                                    {variation.direction === 1 && <MoveUpRight size={10} />}
                                    {variation.direction === -1 && <MoveDownRight size={10} />}
                                    {variation.valueFixed}%
                                </span>
                            </div>

                            {historyHref ? (
                                <Link to={historyHref} className="btn-pill ghost">
                                    <HistoryIcon size={13} /> Historico
                                </Link>
                            ) : (
                                <button className="btn-pill ghost">
                                    <HistoryIcon size={13} /> Historico
                                </button>
                            )}

                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Wallets;
